import styled from "styled-components";
import colours from "styles/colours";
import { fontWeights } from "styles/fonts";

export const LineTableContainer = styled.div`
  width: 100%;
  color: ${colours.elexonBlack};
`;

export const LineTableHeaderRow = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1.3fr 1.1fr 0.4fr;
  column-gap: 1.5em;
  font-weight: ${fontWeights.heavy};
  color: ${colours.elexonBlack};
  padding: 0.75em 1em;
  margin-left: 2em;

  > * {
    min-width: 0;
  }
`;

export const LineTableRow = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1.3fr 1fr 0.5fr;
  column-gap: 1.5em;
  align-items: center;
  margin: 0 0 1em 1em;
  padding: 0.2em 0 0.2em 1em;
  border: 1px solid ${colours.lightGrey};
  border-left: 1px solid ${colours.elexonBlue};
  box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.03),
    0 12px 16px -4px rgba(0, 0, 0, 0.08);

  > * {
    min-width: 0;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    row-gap: 0.5em;
  }
`;
